import { DELAY_UNITS } from '../../../flowConstants';

export default function DelayNode({ id, data }) {
    const delayValue = data?.delayValue ?? '';
    const delayUnit = data?.delayUnit || 'seconds';
    const showTyping = Boolean(data?.showTyping);

    return (
        <div className="mt-2 space-y-2">
            <div className="grid grid-cols-2 gap-2">
                <input type="number" min="1" step="1" className="input3" placeholder="Tempo"
                    value={delayValue}
                    onChange={(e) => data?.onChangeDelay?.(id, { delayValue: e.target.value })} />
                <select className="form-select w-full" value={delayUnit}
                    onChange={(e) => data?.onChangeDelay?.(id, { delayUnit: e.target.value })}>
                    {DELAY_UNITS.map((unit) => (
                        <option key={unit.value} value={unit.value}>{unit.label}</option>
                    ))}
                </select>
            </div>
            <label className="flex items-center gap-2 text-[10px] text-gray-300">
                <input type="checkbox" className="h-3 w-3 rounded border-white/20 bg-white/10"
                    checked={showTyping}
                    onChange={(e) => data?.onChangeDelay?.(id, { showTyping: e.target.checked })} />
                <span>Mostrar digitando</span>
            </label>
        </div>
    );
}
